import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import AppContext from "Contexts/AppContext";
import UserContext from "Contexts/User";
import HeartSave from "../icons/HeartSave";
import ShareVotes from "../icons/ShareVotes";
import Avatars, { AvatarType, defaultAvatar } from "assets/avatars/Avatars";
import { getCreaterData } from "common/utils/helper";

const ActionsWrapper = styled.div`
  position: absolute;
  right: max(12px, calc((100vw - 800px) / 2 + 12px));
  bottom: calc(200px + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  z-index: 101;
  pointer-events: auto;

  @media (max-width: 560px) {
    right: 10px;
    bottom: calc(200px + env(safe-area-inset-bottom));
    gap: 12px;
  }
`;

const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 2px solid #6A29DD;
  background: #6A29DD;
  box-shadow: 0 4px 12px rgba(106, 41, 221, 0.35);
  cursor: pointer;
  transition: box-shadow 160ms ease, transform 160ms ease, border-color 160ms ease;
  color: #fff;

  &:hover {
    box-shadow: 0 6px 14px rgba(106, 41, 221, 0.5);
    border-color: #7C3EE9;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 560px) {
    width: 40px;
    height: 40px;
  }
`;

const ProfileButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 1px solid rgb(255, 255, 255);
  // background: #0B011D;
  overflow: hidden;
  // box-shadow: 0 4px 12px rgba(106, 41, 221, 0.35);
  cursor: pointer;
  // transition: box-shadow 160ms ease, transform 160ms ease, border-color 160ms ease;

  // &:hover {
  //   box-shadow: 0 6px 14px rgba(106, 41, 221, 0.5);
  //   border-color: #7C3EE9;
  // }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 560px) {
    width: 38px;
    height: 38px;
  }
`;

const AiText = styled.span`
  color: #6a29dd;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.5px;
`;

type LikeShareActionsProps = {
  onLike?: () => void;
  onShare?: () => void;
  onProfile?: () => void;
  liked?: boolean;
  userId?: string;
};

const LikeShareActions: React.FC<LikeShareActionsProps> = ({
  onLike,
  onShare,
  onProfile,
  liked = false,
  userId,
}) => {
  const { avatarImage } = useContext(AppContext);
  const { userInfo } = useContext(UserContext);
  const [createrInfo, setCreaterInfo] = useState<any>({});

  useEffect(() => {
    if (!userId) {
      return;
    }
    if (userInfo?.uid === userId) {
      setCreaterInfo(userInfo);
      return;
    }
    getCreaterData(userId || "", setCreaterInfo);

    return (() => { })
  }, [userId]);
  const avatarType = (((createrInfo?.avatar || avatarImage) as AvatarType) || (defaultAvatar as AvatarType));

  return (
    <ActionsWrapper>
      <ActionButton aria-label={liked ? "Unlike" : "Like"} onClick={onLike}>
        <HeartSave on={!!liked} size={22} color={liked ? "#ffffff" : "#6A29DD"} />
      </ActionButton>
      <ActionButton aria-label="Share" onClick={onShare}>
        <ShareVotes />
      </ActionButton>
      <ProfileButton aria-label="Profile" onClick={onProfile}>
        {userId ? (
          <Avatars type={avatarType} width={50} />
        ) : (
          <AiText>AI</AiText>
        )}
      </ProfileButton>
    </ActionsWrapper>
  );
};

export default LikeShareActions;